/**
 * JKD Contact Form 7 — entry module.
 *
 * Imports CF7 styles and boots the SPA reinit shim so Contact Form 7 forms
 * work after page transitions. The reinit is event-driven: the SPA engine
 * (Barba, in the Pro bundle) dispatches `jkd:spa:navigated` on `document`
 * after each swap, and this integration reinits the forms in the new
 * container. That keeps the integration self-contained — it depends on the
 * event contract, never on the theme or Pro.
 */

import '../scss/forms.scss';
import {handleCf7} from './cf7.js';

function boot() {
	handleCf7(document);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot, {once: true});
} else {
	boot();
}

// SPA reinit: rebind CF7 on the freshly swapped container after a transition.
document.addEventListener('jkd:spa:navigated', (event) => {
	const container = event.detail && event.detail.container;
	handleCf7(container instanceof Element ? container : document);
});
